async function loadPickerCatalog(collectionUrl) {
    const sectionName = "picker-variant-data";
    const previewTheme = new URLSearchParams(window.location.search).get("preview_theme_id");
    async function readJson(url) {
        const response = await fetch(url, { credentials: "same-origin" });
        if (!response.ok) throw new Error("Unable to load shirt options (" + response.status + ").");
        return response.json();
    }
    async function readVariantPage(url) {
        const response = await fetch(url, { credentials: "same-origin" });
        if (!response.ok) throw new Error("Unable to load shirt variants (" + response.status + ").");
        const html = new DOMParser().parseFromString(await response.text(), "text/html");
        const element = html.querySelector("[data-picker-variant-page]");
        if (!element) throw new Error("The shirt-variant data section is missing.");
        return JSON.parse(element.textContent);
    }
    const products = [];
    const productIds = new Set();
    for (let page = 1; ; page++) {
        const url = new URL(collectionUrl.replace(/\/$/, "") + "/products.json", window.location.origin);
        url.searchParams.set("limit", "250");
        url.searchParams.set("page", String(page));
        if (previewTheme) url.searchParams.set("preview_theme_id", previewTheme);
        const result = await readJson(url);
        if (!Array.isArray(result.products)) throw new Error("Invalid shirt catalog response.");
        const fresh = result.products.filter(product => !productIds.has(product.id));
        fresh.forEach(product => { productIds.add(product.id); products.push(product); });
        if (result.products.length < 250) break;
        if (!fresh.length) throw new Error("Shirt catalog pagination did not advance.");
    }
    let index = 0;
    async function worker() {
        while (index < products.length) {
            const product = products[index++];
            const variants = [];
            const variantIds = new Set();
            const visited = new Set();
            let url = new URL((window.Shopify?.routes?.root || "/") + "products/" + encodeURIComponent(product.handle), window.location.origin);
            url.searchParams.set("section_id", sectionName);
            if (previewTheme) url.searchParams.set("preview_theme_id", previewTheme);
            let expectedCount = null;
            while (url) {
                if (visited.has(url.href)) throw new Error("Shirt variant pagination did not advance.");
                visited.add(url.href);
                const result = await readVariantPage(url.href);
                if (!Array.isArray(result.variants) || String(result.product_id) !== String(product.id)) throw new Error("Incorrect shirt variant response.");
                expectedCount = Number(result.total);
                for (const variant of result.variants) {
                    if (!variantIds.has(variant.id)) { variantIds.add(variant.id); variants.push(variant); }
                }
                if (result.next) {
                    const next = new URL(result.next, window.location.origin);
                    if (next.origin !== window.location.origin || next.pathname !== url.pathname) throw new Error("Unexpected shirt pagination URL.");
                    next.searchParams.set("section_id", sectionName);
                    if (previewTheme) next.searchParams.set("preview_theme_id", previewTheme);
                    url = next;
                } else url = null;
            }
            if (!Number.isInteger(expectedCount) || variants.length !== expectedCount) throw new Error("Some shirt sizes could not be loaded.");
            product.variants = variants;
        }
    }
    await Promise.all(Array.from({ length: Math.min(4, products.length) }, worker));
    return { products };
}

const urlParams = new URLSearchParams(window.location.search);
const query = Object.fromEntries(urlParams.entries());
let selectedFilters = {};

const addToCartButton = document.getElementById("AddToCart");
const quantityButton = document.getElementById("ProductQuantityPickerInput");
// The <span> inside the Add to cart button holds its label; remember the
// original text so we can restore it once every option is selected.
const addToCartLabelEl = addToCartButton ? addToCartButton.querySelector("span") : null;
const defaultAddToCartText =
	(addToCartButton && addToCartButton.getAttribute("data-text-add-to-cart")) ||
	(addToCartLabelEl && addToCartLabelEl.textContent.trim()) ||
	"Add to cart";
const titleElment = document.querySelector(".product-summary__description-title");
const descriptionElment = document.querySelector(".product-summary__description-inner");
const variantIdElment = document.querySelector("[data-variant-input]");  
const clearFiltersButton = document.getElementById('clear-filters-button');
clearFiltersButton.style.display = 'block';  
clearFiltersButton.addEventListener('click', () => {
    const currentUrl = window.location.href;
    const baseUrl = currentUrl.split('?')[0];
    window.history.pushState(null, null, baseUrl);
    
    const filterButtons = document.querySelectorAll('.filter-button');
    filterButtons.forEach(button => {
            button.classList.remove('active');
            // button.removeAttribute('disabled');
    });

    // Reload the page
    location.reload();
    addToCartButton.disabled = true;
});  
const filters = document.getElementById("filters");
// const filteredItems = document.getElementById("filtered-items");


function setFilterButtonActive(buttons, paramName, paramValue){
	buttons.forEach((btn) => {
		if (selectedFilters[paramName] && btn.id === `${paramName}-${paramValue}`) {
			btn.classList.add("active");
			if (paramName === "size") {
				displayMostPopularSleeveLength(paramValue);
			}
		} else {
			btn.classList.remove("active");
		}
	});    
};

function displayMostPopularSleeveLength(size) {
	const mostPopularSleeveLengths = {
		14: 32,
		14.5: 32,
		15: 33,
		15.5: 33,
		16: 33,
		16.5: 34,
		17: 35,
		17.5: 35,
		18: 35,
		18.5: 35,
		19: 35,
		19.5: 35,
		20: 35,
	};

	const mostPopularSleeveLength = mostPopularSleeveLengths[size];
	const sleeveLengthButtons = document.querySelectorAll(
		".sleeveLength-button"
	);
    const filterName = document.getElementById("filter-name-sleeveLength")
    
	sleeveLengthButtons.forEach((button) => {
		if (button.textContent == mostPopularSleeveLength) {
			button.classList.add("most-popular");
            filterName.classList.add("filter-name-extended")
		} else {
			button.classList.remove("most-popular");
		}
	});
}

function checkAllFiltersSelected() {
	
	return FILTER_DATAKeys.every((key) => selectedFilters.hasOwnProperty(key));
}

function updateAddToCartButton() {
	// Availability is driven by applyFilters (whether a matching variant exists).
	// We intentionally keep the button enabled for incomplete selections so that
	// pressing "Add to cart" can prompt for the next missing option on click.
}

// Label of the first option (in display order) that has no active selection.
function firstUnselectedOptionLabel() {
	let label = null;
	document.querySelectorAll('.filter-option-picker').forEach((option) => {
		if (label) return;
		if (!option.querySelector('.filter-button.active')) {
			label = option.querySelector('.filter-name').innerText.split('.').pop().trim();
		}
	});
	return label;
}

// When a selection is incomplete, the Add to cart button reads
// "Select <next missing option>" and stays disabled; once every option is
// chosen it reverts to its default label and availability (set in
// applyFilters) governs whether it's enabled.
function updateAddToCartLabel() {
	if (!addToCartButton) return;
	const missing = firstUnselectedOptionLabel();
	if (addToCartLabelEl) {
		addToCartLabelEl.textContent = missing ? `Select ${missing}` : defaultAddToCartText;
	}
	if (missing) {
		addToCartButton.disabled = true;
	}
}

function selectFilterButtonsFromURL(FILTER_DATA){
	if (selectedFilters.size) {
		displayMostPopularSleeveLength(selectedFilters.size);
	}
	FILTER_DATA.forEach((filter) => {
		const filterButtons = document.querySelectorAll(`.${filter.name}-button`);
		const filterParam = urlParams.get(filter.name);
       	const activeValue = filterParam || filter.defaultValue;

		if (activeValue) {
			selectedFilters[filter.name] = activeValue;
			setFilterButtonActive(filterButtons, filter.name, activeValue);
            if(filter.show_additional_info){
                document.querySelectorAll('[data-filter-value]').forEach(elm => {
                    if(elm.getAttribute('data-filter-value') === activeValue){
                        elm.classList.remove('hidden')
                    }else{
                        elm.classList.add('hidden')
                    }
                })
            }
		} else {
			// setFilterButtonActive(filterButtons, filter.name, "");
            if (BOOLEAN_keys.indexOf(filter.name) > -1) {
				//selectedFilters[filter.name] = "false";
				setFilterButtonActive(filterButtons, filter.name, "false");
			} else {
				setFilterButtonActive(filterButtons, filter.name, "");
			}
		}
	});
	updateAddToCartButton();
};

function skuParser(originalSku){
    if (!originalSku) return;

    const sku = originalSku.toUpperCase();
    const pick1 = (position) => sku.slice(position, position + 1);
    const lastElement = sku.split("-").pop();
    const dictionary = {
        category: {
            B: "Boys",
            M: "Mens",
            W: "Womans",
            G: "Girls",
        },
        fabric: {
            T: "Twill",
            J: "J-Twill",
            D: "Dobby",
            P: "Pinpoint",
            O: "Oxford",
            Z: "Textured White",
            K: "Knit Stretch"
        },
        collar: {
            S: "Spread",
            C: "Cutaway",
            V: "Extra Cutaway",
            B: "Button",
            P: "Pointy",
        },
        fit: {
            H: "Husky",
            T: "Traditional",
            C: "Classic",
            S: "Slim",
            E: "Extra Slim",
            X: "Super Slim",
            R: "Classic",
        },
        color: {
            CNT8: "Periwinkle Petal",
            CNT9: "Powder Dot",
            CNT10: "Navy Trellis",
            CNT4: "Royal Blue",
            CNT6: "Golden Weave",
            CNT5: "Midnight Tide",
            CNT7: "Night Prism",
            CNT1: "Mini Check",
            CNT2: "Blue Plaid",
            CNT3: "Blue Diamond",
            CNT1SS: "Sky Blue",
            CNT2SS: "Espresso",
            CNT4SS: "Royal Blue",
            CNT8SS: "Periwinkle Petal",
            CNT9SS: "Powder Dot",


        },
    };
    const size = +`${lastElement.replace(/DP/, "").slice(0, 2)}${lastElement.includes("H") ? ".5" : ""}`;
    const sleeveLength = pick1(0) === "M" && !sku.split("-").includes("SS") ? lastElement.slice(sku.includes("/") ? -5 : -2) : sku.split("-").includes("SS")? "Short Sleeve" : "N/A";
    const data = {
        category: dictionary.category[pick1(0)],
        fabric: `${sku.includes("CLN") ? "Clean " : ""}${sku.includes("DP") && pick1(1) == 'T' ? "Soft " : ""}${dictionary.fabric[pick1(1)]}${sku.includes("STRETCH") ? " Stretch" : ""}`,
        collar: dictionary.collar[pick1(2)],
        fit: dictionary.fit[pick1(3)],
        clean: sku.includes("CLN") ? "Yes" : "No",
        cuff: sku.includes("FC") ? "French" : sku.split("-").includes("SS") ? "Short Sleeve" : "Button",
        size,
        sleeveLength,
        pocket: sku.includes("PKT"),
        style: sku.includes("ROL") ? "Chassidish" : "Standard",
        color: sku.includes("CNT") ? dictionary.color[`${sku.split("-").find((x) => x.includes("CNT"))}${sku.split("-").includes("SS") ? "SS" : ""}`] : "White",
    };

    return (
        data.category &&
        data.fabric &&
        data.collar &&
        data.fit &&
        data.cuff &&
        data.size &&
        data
    );
};

function formatMoney(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
  
    function defaultOption(opt, def) {
       return (typeof opt == 'undefined' ? def : opt);
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
  
      if (isNaN(number) || number == null) { return 0; }
  
      number = (number/100.0).toFixed(precision);
  
      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';
  
      return dollars + cents;
    }
  
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
  
    return formatString.replace(placeholderRegex, value);
};


function initCombinedListing(){
    if (addToCartButton) addToCartButton.disabled = true;
    // copyElementBeforeOnMobile('.product-media', '.product-summary__benefits')
    copyElementBeforeOnMobile('.product-breadcrumbs', '.product-media')
    copyElementBeforeOnMobile('.product-summary__rating', '.product-media')
    copyElementBeforeOnMobile('.product-summary__vendor', '.product-media')
    copyElementBeforeOnMobile('.product-summary__title', '.product-media')
    copyElementBeforeOnMobile('.product-summary__price', '.product-media')
    const productMediaCache = {};
    let currentGalleryHandle = null;
    let galleryRequestId = 0;
    let galleryVideoObserver = null;

    loadPickerCatalog(COLLECTION_URL).then((res) => {
        let data = res.products.reduce(
            (acc, { handle, images,body_html, title, variants }) => [
                ...acc,
                ...variants.reduce(
                    (variantsAcc, x) =>
                        skuParser(x.sku) && !x.sku.includes("/")
                            ? [
                                ...variantsAcc,
                                {
                                    ...x,
                                    ...{ handle, images, body_html, title, ...skuParser(x.sku) },
                                },
                            ]
                            : variantsAcc,
                    []
                ),
            ],
            []
        ).filter((x) =>  query ? Object.entries(query).reduce((acc, queryParam) => {
                
                // TODO
                // const queryParamInVariantObject = x[queryParam[0]]+'';                
                // const queryParamValuesArr = queryParam[1].split(",");
                // matchesQuery = acc && (!queryParamInVariantObject || queryParamValuesArr.includes(queryParamInVariantObject.toLowerCase()));
                
                // return matchesQuery;

                return true
            }, true) : true
        );

        data = data.filter((item) => item.available);

        const FIT_ORDER = ["Husky", "Traditional", "Classic", "Slim", "Extra Slim", "Super Slim"];
        const FABRIC_ORDER = ["Twill", "Pinpoint", "Dobby","Oxford","Knit Stretch","Twill Stretch", "Pinpoint Stretch"];

        // Helper to sort sizes numerically
        function sortSizes(values) {
            // Extract numeric part if it’s like "10" or "10S" etc
            return values.sort((a, b) => parseFloat(a) - parseFloat(b));
        }

        // Helper to sort by custom order
        function customSort(sortOrder,values) {
            return values.sort((a, b) => sortOrder.indexOf(a) - sortOrder.indexOf(b));
        }


        // Main logic
        FILTER_DATA.forEach(filter => {
            if (filter.dynamic_values) {
                let uniqueValues = [...new Set(data.map(item => item[filter.name]))].filter(Boolean);

                if (filter.name === "fit") {
                    filter.values = customSort(FIT_ORDER,uniqueValues);
                } else if (filter.name === "fabric") {
                    filter.values = customSort(FABRIC_ORDER,uniqueValues);
                }else if (filter.name === "size") {
                    filter.values = sortSizes(uniqueValues);
                } else {
                    filter.values = uniqueValues.sort();
                }
            }
        });

        FILTER_DATA.forEach((filter, index) => {
            const filterDiv = document.createElement("div");
            filterDiv.className = "filter-option-picker";

            const filterDivLabel = document.createElement("div");
            filterDivLabel.className = "filter-option-picker-label";
            filterDiv.appendChild(filterDivLabel);

            const filterDivValues = document.createElement("div");
            filterDivValues.className = "filter-option-picker-values";
            filterDiv.appendChild(filterDivValues);

            const filterDivValuesList = document.createElement("div");
            filterDivValuesList.className = "filter-option-picker-values-list";
            filterDivValues.appendChild(filterDivValuesList);

            // Add filter name before buttons
            const filterNameValue = filter.displayName || filter.name;
            const filterName = document.createElement("label");
            filterName.className = "filter-name";
            filterName.id = "filter-name-" + filter.name;
            filterName.textContent = `${
                index + 1 + '. ' + filterNameValue.charAt(0).toUpperCase() + filterNameValue.slice(1)
            }`;

            filterArrow = document.createElement("span");
            filterArrow.classList.add('filter-arrow');
            filterArrow.innerHTML = '<svg width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.2362 7.49999L8.73536 0.499999L6.91879 0.499999L0.41797 7.5" stroke="#8B9097"/></svg>'

            filterDivLabel.appendChild(filterName);

            if(filter.tooltip){
                let filterTooltip = document.createElement("span");
                let tooltip_html = `
                            <svg viewBox="0 0 2 6" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="1.29883" y1="1.95313" x2="1.29883" y2="5.95312"/><circle cx="1.23633" cy="0.546875" r="0.5"/></svg>
                `;
                filterTooltip.classList.add("filter-tooltip")
                filterTooltip.innerHTML = tooltip_html;
                filterDivLabel.appendChild(filterTooltip);

                let filterTooltipPopup = document.createElement("div");
                let tooltip_popup_values_html = '';

                filter.values.forEach((value) => {
                    if(filter.info && filter.info[value]){
                        let value_html = '<div>';

                        if(filter.info[value].popup_image){
                            value_html += `<div class="img"><img src="${filter.info[value].popup_image}"/></div>`;
                        }else if(filter.info[value].image){
                            value_html += `<div class="img"><img src="${filter.info[value].image}"/></div>`;
                        }
                        value_html += `
                            <div class="info">
                                <div class="info-title">${value}</div>
                                ${filter.info[value].info || ''}
                            </div>`;

                        if(filter.info[value] && filter.info[value].strength){
                            let infoStrengthLevels = '';
                            for(let i = 0; i < 5; i++){
                                if(filter.info[value].strength > i){
                                    infoStrengthLevels += '<span class="active"></span>'
                                }else{
                                    infoStrengthLevels += '<span></span>'
                                }
                            }
                            infoStrength = `
                                <div class="info-strength">
                                    <span class="info-strength-title">${filter.info[value].title}</span>
                                    <span class="info-strength-label">strength</span>
                                    <span class="info-strength-values">${infoStrengthLevels}</span>
                                </div>`;

                            value_html += infoStrength;
                        }

                        value_html += '</div>';
                        tooltip_popup_values_html += value_html
                    }
                });

                let tooltip_popup_html = `
                        <div class="filter-tooltip-popup-backdrop" onclick="this.closest('.filter-tooltip-popup').classList.remove('open')"></div>
                        <div class="filter-tooltip-popup-inner">
                            <div class="filter-tooltip-popup-header">
                                <div  class="filter-tooltip-popup-title">${filter.tooltip}</div>
                                <div class="filter-tooltip-popup-close" onclick="this.closest('.filter-tooltip-popup').classList.remove('open')">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="24" height="24" rx="12" fill="#F5F3F2"/>
                                        <line x1="7.26763" y1="6.831" x2="17.1671" y2="16.7305" stroke="black" stroke-width="1.5"/>
                                        <line x1="17.168" y1="7.26666" x2="7.26853" y2="17.1662" stroke="black" stroke-width="1.5"/>
                                    </svg>
                                </div>
                                <div class="filter-tooltip-popup-header-message">
                                    <p>${filter.tooltip_message || ''}</p>
                                </div>
                            </div>
                            
                            <div class="filter-tooltip-popup-values">${tooltip_popup_values_html}</div>
                        </div>
                `;
                filterTooltipPopup.classList.add("filter-tooltip-popup")
                filterTooltipPopup.innerHTML = tooltip_popup_html;
                
                filterDivLabel.appendChild(filterTooltipPopup);

                filterTooltip.addEventListener('click', function(){
                    filterTooltipPopup.classList.toggle('open')
                })
            }

            filterDivLabel.addEventListener('click', function(){
                filterDiv.classList.toggle('closed')
            })

            filter.values.forEach((value) => {
                const button = document.createElement("button");
                button.type = 'button';
                button.id = `${filter.name}-${value}`;
                button.className = `${filter.name}-button filter-button`;
                button.innerHTML = '<span class="button-filter-value">' + (value === "true"? "Yes" : value === "false"? "No" : value) + '</span>';
                if(value === 'Twill' || value === 'Cutaway'){
                    button.classList.add("most-popular");
                    filterName.classList.add("filter-name-extended");
                }
                if(filter.image){
                    const image = document.createElement("span");
                    image.innerHTML = ''
                    image.classList.add('image');
                    button.prepend(image);
                    button.classList.add('has-image');
                    if(filter.short){
                        image.classList.add('short');    
                    }
                    if(filter.cover){
                        image.classList.add('cover');    
                    }
                    if(filter.info && filter.info[value] && filter.info[value].image){
                        image.innerHTML = '<img src="'+filter.info[value].image+'"/>';
                    }

                    if(filter.info && filter.info[value] && filter.info[value].strength){
                        let bottomInfo = document.createElement("span");
                        let bottomInfoStrength = document.createElement("span");
                        bottomInfo.classList.add('filter-bottom-info')
                        bottomInfo.innerHTML = '<span class="filter-bottom-info-title">' + filter.info[value].title + '</span><span class="filter-bottom-info-label">strength</span>'
                        bottomInfo.append(bottomInfoStrength)
                        bottomInfoStrength.classList.add('filter-bottom-info-strength')
                        for(let i = 0; i < 5; i++){
                            let bottomInfoStrengthI = document.createElement("span");
                            bottomInfoStrength.append(bottomInfoStrengthI)
                            if(filter.info[value].strength > i){
                                bottomInfoStrengthI.classList.add('active')
                            }
                        }
                        button.append(bottomInfo);
                    }
                    
                }
                
                if(filter.show_additional_info && filter.info && filter.info[value]){
                    let additinalInfo = document.createElement('div');
                    additinalInfo.classList.add('additinal-info');
                    additinalInfo.classList.add('hidden');
                    additinalInfo.setAttribute('data-filter-value', value);
                    additinalInfo.innerHTML = `<div class="additinal-info-content"><div class="additinal-info-title">${value}</div>${filter.info[value].info}</div>`;
                    if(filter.info[value].image){
                        let additinalInfoImg = document.createElement('div');
                        additinalInfoImg.classList.add('additinal-info-img');
                        additinalInfoImg.innerHTML = `<img src="${filter.info[value].image}"/>`;
                        additinalInfo.prepend(additinalInfoImg)
                    }
                    
                    filterDivValues.append(additinalInfo)
                }
                button.addEventListener("click", () => {
                    if (button.classList.contains("active")) {
                        delete selectedFilters[filter.name];
                        setFilterButtonActive(
                            document.querySelectorAll(`.${filter.name}-button`),
                            filter.name,
                            ""
                        );
                    } else {
                        selectedFilters[filter.name] = value;
                        setFilterButtonActive(
                            document.querySelectorAll(`.${filter.name}-button`),
                            filter.name,
                            value
                        );
                    }
                    applyFilters();
                    if(filter.show_additional_info){
                        document.querySelectorAll('[data-filter-value]').forEach(elm => {
                            if(button.classList.contains("active") && elm.getAttribute('data-filter-value') === value){
                                elm.classList.remove('hidden')
                            }else{
                                elm.classList.add('hidden')
                            }
                        })
                    }
                });
                filterDivValuesList.appendChild(button);
            });

            filters.appendChild(filterDiv);

            if(filter.name == 'size' && size_chart_handle){
                let sizeChart = document.createElement("div");
                let size_chart_html = `
                    <product-info-popup class="product-info-popup loading">
                        <a href="${size_chart_handle}" class="product-info-popup__button btn-link" data-page-handle="${size_chart_handle.split('/').pop()}">Size guide</a>
                    </product-info-popup>
                `;
                sizeChart.innerHTML = size_chart_html;
                sizeChart.classList.add('size-chart-link')

                filterDivLabel.appendChild(sizeChart)
            }

            filterDivLabel.appendChild(filterArrow);
        });

        document.querySelector('.product-summary__qty span').innerHTML = FILTER_DATA.length + 1 +'.';

        selectFilterButtonsFromURL(FILTER_DATA);

        // The button label always shows the next missing option (see
        // updateAddToCartLabel). If the shopper presses it while the selection
        // is incomplete, block the add (this also stops the ajax handler in
        // base.js) and keep the label prompting for what's missing.
        addToCartButton.addEventListener('click', (e) => {
            if (!checkAllFiltersSelected()) {
                e.preventDefault();
                e.stopImmediatePropagation();
                updateAddToCartLabel();
            }
        }, true);

        function applyFilters() {

            const filteredData = data.filter((item) =>
                Object.entries(selectedFilters).every(([key, value]) => {
                    if (BOOLEAN_keys.indexOf(key) > -1) {
                        return item[key] === (value === "true");
                    } else if (FLOAT_keys.indexOf(key) > -1) {
                        return item[key] === parseFloat(value);
                    } else {
                        return item[key] === value;
                    }
                })
            );

           
            FILTER_DATA.forEach((filter) => {
                filter.values.forEach((value) => {
                    const button = document.getElementById(`${filter.name}-${value}`);
                    const newFilters = { ...selectedFilters, [filter.name]: value };
                    const results = data.filter((item) =>
                        Object.entries(newFilters).every(([key, value]) => {
                            if (BOOLEAN_keys.indexOf(key) > -1) {
                                return item[key] === (value === "true");
                            } else if (FLOAT_keys.indexOf(key) > -1) {
                                return item[key] === parseFloat(value);
                            } else {
                                return item[key] === value;
                            }
                        })
                    );

                    button.disabled = results.length === 0;
                });
            });

            
            if (filteredData.length > 0) {
                addToCartButton.disabled = false;
                // const quantity = quantityButton.value;
                // const cartUrl = `/cart/add?id=${filteredData[0].id}&quantity=${quantity}`;
                // addToCartButton.setAttribute("data-product-id", filteredData[0].id);
                // addToCartButton.setAttribute("href", cartUrl);

                variantIdElment.value = filteredData[0].id;
                
                if(Object.keys(selectedFilters).length){
                    titleElment.innerText = filteredData[0].title;
                    
                    descriptionElment.innerHTML = filteredData[0].body_html
                    // if(filteredData[0].handle){
                    //     fetchProductDescription(filteredData[0].handle).then((description) => {
                    //         console.log(description)
                    //     })
                    // }else{
                    //     //descriptionElment.innerHTML = '';
                    // }
                

                    var _format = document.querySelector('[data-money-format]').getAttribute('data-money-format') 
                    var _formatMoney = formatMoney(filteredData[0].price, _format);
                    var _formatSaleMoney = formatMoney(filteredData[0].compare_at_price, _format);
                    document.querySelector('[data-price]').innerText = _formatMoney;
                    if (parseFloat(filteredData[0].compare_at_price) > parseFloat(filteredData[0].price)) {
                        document.querySelector('[data-price-compare]').innerText = _formatSaleMoney;
                    }

                    updateGalleryForProduct(filteredData[0], isOnlyDefaultFiltersSelected());
                }
                // const $images = document.querySelectorAll('.product-gallery-images [data-variant-ids]');
                // $images.forEach(($img, index) => {
                //     $img.querySelector('img').removeAttribute('srcset')
                //     if(images[index]){
                //         $img.querySelector('a').href = images[index].src;
                //         $img.querySelector('a').setAttribute('data-pswp-width', images[index].width);
                //         $img.querySelector('a').setAttribute('data-pswp-height', images[index].height);
                //         $img.querySelector('img').src = images[index].src + '&width=600';                        
                //         $img.style.display = 'block';
                //     }else{
                //         $img.style.display = 'none';
                //     }
                // })

            } else {
                addToCartButton.disabled = true;
                addToCartButton.removeAttribute("data-product-id");
            }

            const params = new URLSearchParams();

            Object.entries(selectedFilters).forEach(([key, value]) => {
                params.set(key, value);
            });

            const newUrl = `${window.location.pathname}?${params.toString()}`;
            window.history.pushState({}, "", newUrl);
            document.querySelector('[name="properties[_Filters Link]"]').value = newUrl;
            updateAddToCartButton();
            // Reconcile the label and disable the button while any option is
            // still unselected. Runs last so it overrides the enable above.
            updateAddToCartLabel();
        }

        // function syncGallery(images) {
        //     const ul = document.querySelector('#splide02-list');
        //     if (!ul) return;

        //     const items = Array.from(
        //         ul.querySelectorAll('li.product-gallery-images__image')
        //     );

        //     // 1) Update or remove existing <li>s
        //     items.forEach((li, index) => {
        //         const data = images[index];
        //         if (data) {
        //         const a = li.querySelector('a') || li.appendChild(document.createElement('a'));
        //         const img = li.querySelector('img') || a.appendChild(document.createElement('img'));

        //         img.removeAttribute('srcset');
        //         a.href = data.src;
        //         a.setAttribute('data-pswp-width', data.width);
        //         a.setAttribute('data-pswp-height', data.height);

        //         img.src = data.src + '&width=600';
        //         img.alt = data.alt || `Product image ${index + 1}`;
        //         li.style.display = 'block';
        //         } else {
        //         // no matching image -> remove extra node
        //         li.remove();
        //         }
        //     });

        //     // 2) Append new <li>s if there are more images than items
        //     for (let i = items.length; i < images.length; i++) {
        //         ul.appendChild(buildLi(images[i], i));
        //     }

        //     // 3) If this list is inside a Splide, refresh it so it recalculates slides
        //     const splide = ul.closest('.splide')?.splide;
        //     if (splide) splide.refresh();
        // }

        function defaultFilters() {
            return FILTER_DATA.reduce((defaults, filter) => {
                if (filter.defaultValue) {
                    defaults[filter.name] = filter.defaultValue;
                }

                return defaults;
            }, {});
        }

        function isOnlyDefaultFiltersSelected() {
            const defaults = defaultFilters();
            const selectedEntries = Object.entries(selectedFilters);

            return selectedEntries.length > 0 &&
                selectedEntries.length === Object.keys(defaults).length &&
                selectedEntries.every(([key, value]) => defaults[key] === value);
        }

        function mediaType(media) {
            return media.media_type || media.mediaContentType;
        }

        function moveVideosLast(media) {
            const galleryMedia = Array.isArray(media) ? media : [];
            const videos = galleryMedia.filter((item) => mediaType(item) === "video" || mediaType(item) === "VIDEO");
            const otherMedia = galleryMedia.filter((item) => mediaType(item) !== "video" && mediaType(item) !== "VIDEO");

            return [...otherMedia, ...videos];
        }

        async function updateGalleryForProduct(productData, defaultOnly = false) {
            if (!productData) return;

            const requestId = ++galleryRequestId;
            const handle = productData.handle;

            if (!handle) {
                syncGallery(defaultOnly ? moveVideosLast(productData.images || []) : productData.images || []);
                return;
            }

            if (currentGalleryHandle === handle && productMediaCache[handle]) {
                syncGallery(defaultOnly ? moveVideosLast(productMediaCache[handle]) : productMediaCache[handle]);
                return;
            }

            try {
                const media = await fetchProductMedia(handle, productData.images || []);
                if (requestId !== galleryRequestId) return;

                currentGalleryHandle = handle;
                productMediaCache[handle] = media;
                syncGallery(defaultOnly ? moveVideosLast(media) : media);
            } catch (error) {
                console.error("Product media fetch failed:", error);
                if (requestId === galleryRequestId) {
                    syncGallery(defaultOnly ? moveVideosLast(productData.images || []) : productData.images || []);
                }
            }
        }

        async function fetchProductMedia(handle, fallbackImages) {
            if (productMediaCache[handle]) {
                return productMediaCache[handle];
            }

            const routesRoot = window.Shopify?.routes?.root || "/";
            const response = await fetch(`${routesRoot}products/${handle}.js`);
            if (!response.ok) {
                throw new Error(`Failed to fetch product media for ${handle}`);
            }

            const product = await response.json();
            const media = Array.isArray(product.media) && product.media.length ? product.media : fallbackImages;

            return media.length ? media : fallbackImages;
        }

        function imageUrl(url, width) {
            if (!url) return "";
            const separator = url.includes("?") ? "&" : "?";
            return `${url}${separator}width=${width}`;
        }

        function escapeHtml(value) {
            return String(value || "")
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
        }

        function pickVideoSource(media) {
            const sources = Array.isArray(media.sources) ? media.sources : [];
            const mp4Sources = sources.filter((source) => source.mime_type === "video/mp4" || source.mimeType === "video/mp4");

            return (
                mp4Sources.find((source) => Number(source.height) >= 720) ||
                mp4Sources[0] ||
                sources[0] ||
                {}
            );
        }

        function renderGallerySlide(data, index) {
            const mediaType = data.media_type || data.mediaContentType;

            if (mediaType === "video" || mediaType === "VIDEO") {
                const source = pickVideoSource(data);
                const src = source.url || "";
                const mimeType = source.mime_type || source.mimeType || "video/mp4";
                const previewImage = data.preview_image || data.preview?.image || {};
                const poster = previewImage.src || previewImage.url || "";
                const width = data.width || source.width || previewImage.width || 1200;
                const height = data.height || source.height || previewImage.height || 1500;

                return `
                <li class="splide__slide product-gallery-images__image product-gallery-images__video">
                    <video
                        autoplay
                        muted
                        loop
                        playsinline
                        preload="metadata"
                        style="display: block; width: 100%; height: auto;"
                        width="${width}"
                        height="${height}"
                        ${poster ? `poster="${escapeHtml(poster)}"` : ""}
                    >
                        <source src="${escapeHtml(src)}" type="${escapeHtml(mimeType)}">
                    </video>
                </li>
                `;
            }

            const src = data.src || data.image?.url || data.preview_image?.src || data.preview?.image?.url || "";
            const width = data.width || data.image?.width || data.preview_image?.width || data.preview?.image?.width || 1200;
            const height = data.height || data.image?.height || data.preview_image?.height || data.preview?.image?.height || 1500;

            return `
                <li class="splide__slide product-gallery-images__image">
                    <a href="${escapeHtml(src)}" data-pswp-width="${width}" data-pswp-height="${height}">
                    <img
                        src="${escapeHtml(imageUrl(src, 600))}"
                        alt="${escapeHtml(data.alt || `Product image ${index + 1}`)}"
                    >
                    </a>
                </li>
                `;
        }

        function syncGallery(media) {
            const splideEl = document.querySelector('#splide02');
            if (!splideEl) return;

            const ul = splideEl.querySelector('#splide02-list');
            if (!ul) return;

            const galleryMedia = Array.isArray(media) ? media : [];

            const splideInstance = splideEl.splide;

            // fully destroy current instance first
            if (splideInstance) {
                splideInstance.destroy(true);
            }

            // rebuild all slides from scratch
            ul.innerHTML = galleryMedia.map(renderGallerySlide).join('');

            // create a brand new Splide instance
            const newSplide = new Splide(splideEl, {
                perPage: 1,
                arrows: true,
                pagination: false,
                rewind: false
            });

            newSplide.mount();
            initGalleryVideoAutoplay(splideEl);
        }

        function initGalleryVideoAutoplay(splideEl) {
            const videos = splideEl.querySelectorAll("video");

            if (galleryVideoObserver) {
                galleryVideoObserver.disconnect();
            }

            if (!videos.length) return;

            const playVideo = (video) => {
                video.muted = true;
                video.playsInline = true;

                const playPromise = video.play();
                if (playPromise && typeof playPromise.catch === "function") {
                    playPromise.catch(() => {});
                }
            };

            galleryVideoObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    const video = entry.target;

                    if (entry.isIntersecting) {
                        playVideo(video);
                    } else {
                        video.pause();
                    }
                });
            }, { threshold: 0.45 });

            videos.forEach((video) => {
                galleryVideoObserver.observe(video);
            });
        }

        function buildLi(data, i) {
            const li = document.createElement('li');
            li.className = `product-gallery-images__image product-gallery-images__image-${i + 1} splide__slide`;
            li.setAttribute('role', 'tabpanel');
            li.style.width = 'calc(100%)';

            const a = document.createElement('a');
            a.href = data.src;
            a.setAttribute('data-pswp-width', data.width);
            a.setAttribute('data-pswp-height', data.height);

            const img = document.createElement('img');
            img.src = data.src + '&width=600';
            img.alt = data.alt || `Product image ${i + 1}`;
            img.loading = 'lazy';

            a.appendChild(img);
            li.appendChild(a);
            return li;
        }

        applyFilters()
        
    }).catch((error) => {
        console.error(error);
        if (addToCartButton) addToCartButton.disabled = true;
        const filtersElement = document.getElementById("filters");
        if (filtersElement) {
            const message = document.createElement("p");
            message.setAttribute("role", "alert");
            message.textContent = "Shirt options could not be loaded. Please refresh this page to try again.";
            filtersElement.replaceChildren(message);
        }
    });

}

initCombinedListing()



function copyElementBeforeOnMobile(sourceSelector, targetSelector) {
    // Check if device is mobile (e.g., screen width less than or equal to 768px)
    if (window.matchMedia("(max-width: 768px)").matches) {
      const source = document.querySelector(sourceSelector);
      const target = document.querySelector(targetSelector);
  
      if (source && target) {
        const copy = source;//source.cloneNode(true); // deep clone
        target.parentNode.insertBefore(copy, target);
      } else {
        console.error('One or both elements not found.');
      }
    }
}

let currentController = null;

async function fetchProductDescription(handle) {
  // Abort the previous request if still running
  if (currentController) {
    currentController.abort();
  }

  // Create new controller for this request
  currentController = new AbortController();
  const { signal } = currentController;

  try {
    const res = await fetch(`/products/${handle}.js`, { signal });
    if (!res.ok) throw new Error("Failed to fetch product");

    const product = await res.json();
    console.log("Description:", product.body_html);
    return product.body_html;
  } catch (err) {
    if (err.name === "AbortError") {
      console.log("Previous request aborted");
    } else {
      console.error("Fetch error:", err);
    }
  }
}
